import { rfqConfirmationDetailsStyles } from "@insite/content-library/Widgets/RfqConfirmation/RfqConfirmationDetails";
import { css } from "styled-components";

Object.assign(rfqConfirmationDetailsStyles, {
    ...rfqConfirmationDetailsStyles,
    jobNameHeadingAndText: {
        heading: { transform: "initial", weight: 600, size: 16 },
    },
    salesRepGridItem: { width: [6, 6, 4, 4, 4] },
    salesRepHeadingAndText: {
        heading: { transform: "initial", weight: 600, size: 16 },
        text: { size: 14 },
    },
    statusGridItem: { width: [6, 6, 4, 4, 4] },
    statusHeadingAndText: {
        heading: { transform: "initial", weight: 600, size: 16 },
        text: { size: 14 },
    },
    dateGridItem: {
        width: [6, 6, 4, 4, 4],
        css: css`
            flex-direction: column;
            font-size: 14px;
        `,
    },
    dateLabelText: {
        weight: 600,
        size: 16,
        // css: css`
        //     margin-bottom: 0.3em;
        // `,
    },
    customerGridItem: { width: 12 },
    customerHeadingAndText: {
        heading: { transform: "initial", weight: 600, size: 16 },
        text: { size: 14 },
    },
    shipToGridItem: { width: 12 },
    shipToHeadingAndText: {
        heading: { transform: "initial", weight: 600, size: 16 },
        text: { size: 14 },
    },
    rightColumnGridItem: { width: [12, 12, 12, 6, 6] },
    notesHeadingAndText: {
        heading: { transform: "initial", weight: 600, size: 16 },
        text: { size: 14 },
    },
});
